import React from "react";
import { useOutletContext } from "react-router-dom";
import { useQuote } from "./QuoteProvider";
import { FileText, Phone, MessageCircle } from "lucide-react";

export default function MobileStickyBar() {
  const { settings } = useOutletContext() || { settings: {} };
  const { openQuote } = useQuote();
  const s = settings || {};
  const phone = (s.phone || "").replace(/\s/g, "");
  const wa = (s.whatsapp || "").replace(/[^0-9]/g, "");
  const waUrl = `https://wa.me/${wa}?text=${encodeURIComponent("Hello SSK Enterprises, I would like to request a quotation.")}`;

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 shadow-[0_-8px_20px_-8px_rgba(15,23,42,0.15)] grid grid-cols-3" data-testid="mobile-sticky-bar">
      <a href={`tel:${phone}`} className="flex flex-col items-center justify-center py-3 text-[11px] font-semibold text-slate-700 border-r border-slate-200" data-testid="msb-call">
        <Phone className="w-5 h-5 mb-1 text-[#0F2747]" /> Call
      </a>
      <a href={waUrl} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center py-3 text-[11px] font-semibold text-slate-700 border-r border-slate-200" data-testid="msb-whatsapp">
        <MessageCircle className="w-5 h-5 mb-1 text-[#25D366]" /> WhatsApp
      </a>
      <button onClick={() => openQuote()} className="flex flex-col items-center justify-center py-3 text-[11px] font-semibold text-white bg-[#B5121B]" data-testid="msb-quote">
        <FileText className="w-5 h-5 mb-1" /> Get Quote
      </button>
    </div>
  );
}
